import { emailRegex } from './constants.js';

class EmailUtils {
    /**
     * Validates if the provided string is a valid email address
     * @param {string} email - The email address to validate
     * @returns {boolean} - True if email is valid, false otherwise
     */
    static isValidEmail(email) {
        if (!email || typeof email !== 'string') {
            return false;
        }
        if (email.length === 0 || email.length > 254) {
            return false;
        }
        return emailRegex.test(email);
    }
}

export default EmailUtils;